import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

class CartService {
  async create(payload) {
    try {
      const res = await axiosInstance.post(ENDPOINTS.CART.CREATE, payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async list(params, options = {}) { // Accept params and request options
    const { skipAuth = true, cacheBust = false } = options;
    try {
      const requestParams = cacheBust
        ? { ...(params || {}), _t: Date.now() }
        : params;
      const res = await axiosInstance.get(ENDPOINTS.CART.LIST, {
        params: requestParams,
        skipAuth,
        // Prevent browser/proxy caching that can cause stale 304 responses
        headers: {
          'Cache-Control': 'no-store, no-cache, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
      return res.data;
    } catch (error) {
      console.error('cartService.list error', error);
      throw error;
    }
  }

  async updateQuantity(uuid, quantity) {
    try {
      const res = await axiosInstance.put(ENDPOINTS.CART.UPDATE_QUANTITY(uuid), { quantity });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async updateUserCart(payload) {
    // payload: { user_uuid, ip_address }
    try {
      const res = await axiosInstance.put(ENDPOINTS.CART.UPDATE_USER, payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(uuid) {
    try {
      const res = await axiosInstance.delete(ENDPOINTS.CART.DELETE(uuid));
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}

const cartService = new CartService();
export default cartService;
